export const milCodeList = [
  {
    color: '#F2453D',
    flashing: false,
    mil: 128,
    status: 'Malfunction Indicator Lamp',
  },
  { color: '#F2453D', flashing: false, mil: 64, status: 'Red Stop Lamp' },
  { color: '#F2453D', flashing: false, mil: 16, status: 'Protect Lamp' },
  {
    color: '#F2453D',
    flashing: true,
    mil: 8,
    status: 'Flashing Malfunction Indicator Lamp',
  },
  {
    color: '#F2453D',
    flashing: true,
    mil: 4,
    status: 'Flashing Red Stop Lamp',
  },
  { color: '#F2453D', flashing: true, mil: 1, status: 'Flashing Protect Lamp' },
  { color: '#FFC107', flashing: false, mil: 32, status: 'Amber Warning Lamp' },
  {
    color: '#FFC107',
    flashing: true,
    mil: 2,
    status: 'Flashing Amber Warning Lamp',
  },
  { color: '#E5E5E5', flashing: false, mil: 0, status: 'No Lamp' },
];
